import { darkPalette } from '../../palette/dark';
import { UnifiedBaseTypography } from '../UnifiedBaseTypography';
import { components } from '../components';
import { unifiedDarkPageTheme } from './unifiedDarkPageTheme';
import {
  createUnifiedTheme,
  createBaseThemeOptions,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';

/**
 * Configures the application's dark theme, including custom colors, typography, and
 * component styles, to create a unified dark mode appearance.
 *
 * - `createBaseThemeOptions` initializes essential options like color palette and typography.
 * - `createUnifiedTheme` builds upon the base, integrating page-specific themes.
 *
 * @category Theming
 */
export const unifiedDarkTheme = createUnifiedTheme({
  mode: 'dark',
  // Core theme settings, integrating custom color palette and typography.
  ...createBaseThemeOptions({
    palette: darkPalette, // Custom dark mode color scheme
    typography: UnifiedBaseTypography, // Typography settings using the Rubik font family
    defaultPageTheme: 'home', // Sets the initial page theme to 'home'
  }),

  // Default theme applied to any page without an explicitly defined theme
  defaultPageTheme: 'home',

  // Global font family for consistent typography styling across the app
  fontFamily: 'Rubik',

  // Defines page-specific themes for different sections, configuring header colors and shapes
  pageTheme: unifiedDarkPageTheme,

  components,
});
